import ChartGroup from "./ChartGroup";

const Chart = ({
  chartRef,
  chartTitle,
  chartSubtitle,
  fuel,
  toolConfig,
  selectedEntity,
  selectedCountry,
  selectedCountries,
  data,
  isLoading,
  selectedYear,
  setSelectedYear,
  maxValue,
  handleYearChange,
}) => {
  return (
    <ChartGroup
      chartRef={chartRef}
      chartTitle={chartTitle}
      chartSubtitle={chartSubtitle}
      fuel={fuel}
      toolConfig={toolConfig}
      selectedEntity={selectedEntity}
      selectedCountry={selectedCountry}
      selectedCountries={selectedCountries}
      data={data}
      isLoading={isLoading}
      setSelectedYear={setSelectedYear}
      selectedYear={selectedYear}
      handleYearChange={handleYearChange}
      maxValue={maxValue}
    />
  );
};

export default Chart;
